export const languageSelectorEn = {
  label: 'Interface language',
  options: {
    automatic: 'Automatic',
    en: 'English',
    ru: 'Russian',
  },
  automaticDescription: 'Automatic · guild default, then browser',
}

export const emojiPickerEn = {
  chooseEmoji: 'Choose an emoji',
  insertEmoji: 'Insert emoji',
  insert: (emoji: string) => `Insert ${emoji}`,
}

export const guildSelectorEn = {
  activeGuild: 'Active guild',
  switchGuild: 'Switch guild',
  restrictedGuilds: 'Restricted guilds',
  loadingGuilds: 'Loading guilds…',
  noGuilds: 'No guilds currently accessible.',
  addBot: 'Add the bot to your Discord server',
  preparingBotInvite: 'Preparing bot invite…',
  botInviteFailed: 'Bot invite unavailable.',
  guildAccessRequired: 'Guild access required',
  selectGuild: 'Select a guild',
  requestGuildAccess: 'Request guild access',
  selectActiveGuild: 'Select active guild',
  activeGuildLabel: (name: string) => `Active guild: ${name}`,
  available: (count: number) => `${count} available`,
  availableAndRestricted: (available: number, restricted: number) =>
    `${available} available · ${restricted} restricted`,
  roles: {
    owner: 'Owner',
    officer: 'Officer',
    member: 'Member',
  },
  access: {
    boardEditingEnabled: 'Board editing enabled',
    viewOnly: 'View-only access',
    requestPending: 'Access request pending',
    discordRoleRequired: 'Discord role required to view',
  },
  request: {
    pending: 'Pending',
    requesting: 'Requesting…',
    requestAccess: 'Request access',
  },
}

export const appDrawerEn = {
  close: 'Close',
  closeTitle: (title: string) => `Close ${title}`,
}
